import { ClinicData, ClinicId } from '../types';
import { getClinicConfig } from '../clinicPalette';

interface Props {
  clinics: ClinicData[];
  selected: Set<ClinicId>;
  onClinicClick?: (clinic: ClinicId) => void;
}

const fmt = (n: number) => n.toLocaleString('en-US');

export default function ClinicPills({ clinics, selected, onClinicClick }: Props) {
  const isFiltering = selected.size < clinics.length;
  return (
    <div className="clinic-pills">
      {clinics.map((c) => {
        const cfg = getClinicConfig(c.id);
        const muted = isFiltering && !selected.has(c.id);
        return (
          <button
            key={c.id}
            type="button"
            className={`clinic-pill${muted ? ' muted' : ''}`}
            style={{ background: cfg.pillBg, borderColor: cfg.pillBorder }}
            onClick={() => onClinicClick?.(c.id)}
          >
            <span className="pill-dot" style={{ background: cfg.hex }} />
            <span className="pill-name">{cfg.displayName}</span>
            <span className="pill-count num-eng">{fmt(c.count)}</span>
            <span className="pill-sep">·</span>
            <span className="pill-pct num-eng">{Math.round(c.pct)}%</span>
          </button>
        );
      })}
    </div>
  );
}
